import * as THREE from "three";
import { glowVertexShader, glowFragmentShader } from "../shaders/glowBackground.js";

export class AmbientGlowBackground {
  constructor(scene) {
    this.group = new THREE.Group();
    scene.add(this.group);

    this.glowUniforms = {
      uTime: { value: 0 },
      uPointer: { value: new THREE.Vector2() },
      uFade: { value: 1 },
    };

    this.glowPlane = new THREE.Mesh(
      new THREE.PlaneGeometry(64, 40, 1, 1),
      new THREE.ShaderMaterial({
        uniforms: this.glowUniforms,
        vertexShader: glowVertexShader,
        fragmentShader: glowFragmentShader,
        transparent: true,
        depthWrite: false,
        blending: THREE.AdditiveBlending,
      })
    );
    this.glowPlane.position.z = -15;
    this.group.add(this.glowPlane);
  }

  update(elapsed, pointer) {
    this.glowUniforms.uTime.value = elapsed;
    this.glowUniforms.uPointer.value.set(pointer.x, pointer.y);
    this.glowUniforms.uFade.value = 1;
    this.group.position.y = Math.sin(elapsed * 0.22) * 0.12;
  }
}
